import { Tag } from "@walmart-web/livingdesign-components";
import React from "react";
import { RATE_STATUS_LABELS } from "../../../constants/constants";

const RateRequestStatus = ({ detail, variant="primary" }) => {
  const status = detail?.status?.toLowerCase();
  switch (status) {
    case 'submitted':
      return <Tag id={"matter-specific-rates-submitted-tag"} data-testid="submitted" color='spark' variant={variant}>{RATE_STATUS_LABELS.SUBMITTED}</Tag>;
    case 'active':
      return <Tag id={"matter-specific-rates-active-tag"} data-testid="active" color='green' variant={variant}>{RATE_STATUS_LABELS.ACTIVE}</Tag>;
    case 'inactive':
      return <Tag id={"matter-specific-rates-inactive-tag"}data-testid="inactive" color='gray' variant={variant}>{RATE_STATUS_LABELS.INACTIVE}</Tag>;
    case 'rejected':
      return <Tag id={"matter-specific-rates-rejected-tag"} data-testid="rejected" color='red' variant={variant}>{RATE_STATUS_LABELS.REJECTED}</Tag>;
    case 'expired':
      return <Tag id={"matter-specific-rates-expired-tag"} data-testid="expired" color='gray' variant={variant}>{RATE_STATUS_LABELS.EXPIRED}</Tag>;
    case 'pending':
      return <Tag id={"matter-specific-rates-pending-tag"} data-testid="pending" color='spark' variant={variant}>{RATE_STATUS_LABELS.PENDING}</Tag>;
    case 'invalid':
      return <Tag id={"matter-specific-rates-invalid-tag"} data-testid="invalid" color='red' variant={variant}>{RATE_STATUS_LABELS.INVALID}</Tag>;
    case 'draft':
      return <Tag id={"matter-specific-rates-draft-tag"} color='spark' data-testid="draft" variant={variant}>{RATE_STATUS_LABELS.DRAFT}</Tag>;
    default:
      return <React.Fragment></React.Fragment>
  }
}

export default RateRequestStatus;
